"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _common = require("../../common");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Content = props => {
  const {
    type
  } = props;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  switch (type) {
    case 'catalogue':
      {
        const {
          dateRange,
          title
        } = props;
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CatalogueDateRange, {
            "data-testid": getTestId(_common.BANNER_CATALOGUE_DATE_RANGE),
            children: dateRange
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CatalogueTitle, {
            component: "p",
            variant: "h6",
            "data-testid": getTestId(_common.BANNER_CATALOGUE_TITLE),
            children: title
          })]
        });
      }
    case 'custom':
      {
        const {
          customContent
        } = props;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          "data-testid": getTestId(_common.BANNER_CUSTOM_CONTENT),
          children: customContent
        });
      }
    case 'quiz':
      {
        const {
          text,
          title,
          maxLines
        } = props;
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.QuizTitle, {
            maxLines: maxLines,
            "data-testid": getTestId(_common.BANNER_QUIZ_TITLE),
            children: title
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.QuizText, {
            "data-testid": getTestId(_common.BANNER_QUIZ_TEXT),
            maxLines: maxLines,
            children: text
          })]
        });
      }
    default:
      return null;
  }
};
exports.Content = Content;
